import React from 'react';

const Auth = () => {
    return <h1>404 - Página não encontrada!</h1>
}

export default Auth;